import { FC } from "react";
import { Typography } from "../Typography";
import { FileTypeIcon } from "./FileTypeIcon";
import styles from "./DocumentCard.module.less";

function formatDate(date: Date | string): string {
    const d = typeof date === "string" ? new Date(date) : date;
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export interface DocumentCardProps {
    name: string;
    uploadedBy?: string;
    uploadedAt?: Date | string;
}

export const DocumentCard: FC<DocumentCardProps> = ({ name, uploadedBy, uploadedAt }) => {
    return (
        <div className={styles.card}>
            <FileTypeIcon filename={name} />
            <div className={styles.content}>
                <div className={styles.name}>{name}</div>
                {(uploadedBy || uploadedAt) && (
                    <Typography.Text type="secondary" className={styles.meta}>
                        {uploadedBy}{uploadedBy && uploadedAt && " · "}{uploadedAt && formatDate(uploadedAt)}
                    </Typography.Text>
                )}
            </div>
        </div>
    );
};
